import Text from '@deprecated-ui/common/Text';

const Rules = () => (
  <>
    <p>
      <Text family="bold" as="span">
        Stockbit
      </Text>{' '}
      memiliki beberapa panduan yang diharapkan untuk diikuti mayoritas untuk
      menjaga integritas dan manfaat platform Stockbit.
    </p>
    <p>Pelanggaran atas aturan ini akan ditindaklanjuti tanpa peringatan.</p>
    <Text family="bold" as="h3" id="do-s" style={{ marginBottom: '0.8em' }}>
      Do&#39;s
    </Text>
    <ul>
      <li>Be Nice. Be Respectful</li>
      <li>
        Jadikan stockbit sebagai platform untuk belajar, baik saham, maupun
        kepenulisan.
      </li>
      <li>Menghargai pendapat orang lain</li>
      <li>Saring sebelum Sharing</li>
      <li>Memberi masukan atau kritik yang konstruktif</li>
      <li>Memperhatikan sopan santun dan etika dalam berinteraksi</li>
      <li>Membagikan ide brilian mu kepada user lain agar saling belajar</li>
    </ul>
    <Text family="bold" as="h3" id="don-t" style={{ marginBottom: '0.8em' }}>
      Don&#39;ts
    </Text>
    <ul>
      <li>
        Memposting hal yang serupa dalam waktu yang bersamaan (Spam,
        advertising)
      </li>
      <li>Provokasi kepada hal yang tidak baik</li>
      <li>
        Mengumbar kebencian (termasuk <em>bullying</em> dan menghasut)
      </li>
      <li>Menghina orang lain dalam bentuk publik maupun privat</li>
      <li>Menghina SARA</li>
      <li>Mendorong konten pornografi dan sejenisnya</li>
      <li>Menjadikan stockbit sebagai lapak jualan pribadi</li>
      <li>
        Menyebarkan gambar <em>explicit</em> (<em>nudity</em>,{' '}
        <em>abusive behavior</em>, dsb)
      </li>
      <li>
        Meminta password dan PIN <em>trading</em> kepada orang lain.
      </li>
      <li>
        Memberikan data pribadi berikut dengan password dan PIN <em>trading</em>{' '}
        kepada orang lain.
      </li>
    </ul>
    <Text
      family="bold"
      as="h3"
      id="peringatan"
      style={{ marginBottom: '0.8em' }}
    >
      PERINGATAN!
    </Text>
    <p>
      <em>
        Stockbit tidak pernah meminta pengguna untuk memberikan password, PIN
        trading, atau OTP (One-Time Password) untuk kebutuhan apapun.
      </em>
    </p>
    <Text family="bold" as="h3" id="privasi" style={{ marginBottom: '0.8em' }}>
      Privasi
    </Text>
    <p>
      Stockbit berkomitmen untuk selalu menjaga data pribadi. Dihimbau untuk{' '}
      <strong>TIDAK</strong> memposting dan memberikan segala sesuatu yang
      memuat data pribadi (seperti KTP, nomor telepon, dan segala jenis
      identitas lainnya dalam segala bentuk) atau privasi data yang menyangkut
      dengan institusi yang bersifat rahasia.
    </p>
    <p>
      Jika ada aktivitas atau pihak mencurigakan yang memberikan kontak
      seakan-akan milik Stockbit, segera lapor dan verifikasi ke Customer
      Support Stockbit melalui WhatsApp +622150864219 atau email
      support@stockbit.com.
    </p>
    <p>
      Stockbit tidak bertanggung jawab atas kerugian materil dan immaterial yang
      disebabkan penyebaran data pribadi oleh pengguna.
    </p>
    <Text
      family="bold"
      as="h3"
      id="ide-berkualitas"
      style={{ marginBottom: '0.8em' }}
    >
      Ide Berkualitas
    </Text>
    <p>
      Untuk membangun suatu komunitas saham yang berkualitas, kami berharap
      semua ide yang di share di Stockbit dapat disertai alasan yang menarik
      dengan landasan yang kuat untuk dijadikan tempat pembelajaran.
    </p>
    <p>
      <Text family="bold" as="span">
        Hal yang perlu kamu hindari:
      </Text>
    </p>
    <ul>
      <li>
        <strong>Menyebarkan rumor palsu tentang saham tertentu.</strong>
      </li>
      <li>
        Posting message yang sangat mirip beberapa kali dengan tujuan menggiring
        perhatian publik terhadap suatu saham.
      </li>
      <li>
        Memberi $ tag untuk suatu post yang tidak berkualitas. Hal-hal yang
        tidak penting sebaiknya tidak perlu di tag.
      </li>
      <li>
        Menulis hal yang bersifat tidak relevan untuk dibagikan di forum saham.
      </li>
      <li>
        <em>Repost</em> konten secara berkala dengan tujuan pom-pom atau
        promosi.
      </li>
      <li>
        Membagikan password, PIN trading dan data lainnya yang bersifat pribadi
        kepada orang lain.
      </li>
    </ul>
    <p>
      Kami berharap tujuan semua untuk sharing ide di Stockbit adalah untuk
      saling belajar dari sesama.
    </p>
    <Text
      family="bold"
      as="h3"
      id="dilarang-iklan"
      style={{ marginBottom: '0.8em' }}
    >
      Dilarang Iklan
    </Text>
    <p>
      Kami berharap anggota Stockbit tidak mempromosikan produk dan jasa kepada
      anggota lain. Berikut adalah kegiatan yang tidak diizinkan:
    </p>
    <ul>
      <li>
        Pesan yang berisi promosi dagang atau jasa, termasuk grup saham gratis
        maupun berbayar.
      </li>
      <li>
        Pesan yang berisi promosi tentang aplikasi investasi selain milik grup
        Stockbit.
      </li>
      <li>
        Mengirim reply, mention atau private message untuk mempromosikan layanan
        atau produk berbayar.
      </li>
      <li>Membuka lapak jualan di stockbit</li>
    </ul>
    <Text family="bold" as="h3" id="tip-jar" style={{ marginBottom: '0.8em' }}>
      Tip Jar
    </Text>
    <p>
      Tip Jar hanya dapat digunakan untuk memberikan apresiasi kepada para
      penulis pada Stockbit Stream berbentuk uang dengan nominal tertentu.
      Berikut hal yang tidak bisa dilakukan dengan fitur Tip Jar:
    </p>
    <ul>
      <li>
        Dilarang berjualan grup berbayar atau premium dengan transaksi melalui
        Tip Jar.
      </li>
      <li>
        Dilarang memberikan Tip Jar dengan motif untuk mendapatkan rekomendasi
        berbentuk <em>stockpick</em>.
      </li>
      <li>Dilarang memanfaatkan Tip Jar sebagai alat transaksi ilegal.</li>
    </ul>
    <p>
      Harap memanfaatkan fitur Tip Jar dengan baik dan benar. Segala bentuk
      penyalahgunaan fitur Tip Jar akan kami tindak tegas sesuai prosedur yang
      berlaku.
    </p>
    <Text family="bold" as="h3" id="etika" style={{ marginBottom: '0.8em' }}>
      Etika
    </Text>
    <p>
      Kami berharap Stockbitor bisa menjaga etika yang baik supaya komunitas
      kita bisa berfungsi dengan harmonis. Berikut bisa dipakai sebagai panduan:
    </p>
    <ul>
      <li>
        Jujur jika membuat kesalahan. Semua orang bisa salah termasuk analis
        yang paling handal pun. Yang penting adalah cara kita mengatasi
        kesalahan kita.
      </li>
      <li>
        Selalu rendah hati dan menghargai orang lain, sekalipun kamu mampu
        melakukan analisa yang baik.
      </li>
      <li>
        Ide di Stockbit sebaiknya diperlakukan sebagai dorongan untuk berpikir
        dan membuat analisa kita sendiri.
      </li>
      <li>
        Jangan mengikuti rekomendasi orang tanpa mempertimbangkan resikonya
        terlebih dahulu. Resiko selalu kita tanggung masing-masing.
      </li>
    </ul>
    <Text
      family="bold"
      as="h3"
      id="perlakuan-kasar"
      style={{ marginBottom: '0.8em' }}
    >
      Perlakuan Kasar
    </Text>
    <p>
      Kami melarang keras adanya serangan pribadi kepada user lain maupun
      anggota kami di Stockbit. Perilaku berikut tidak diizinkan:
    </p>
    <ul>
      <li>
        Mengirim pesan yang bersifat menghina atau melecehkan orang lain di
        Stockbit.
      </li>
      <li>Mengirim pesan yang mengancam orang lain di Stockbit.</li>
      <li>
        Mengirim pesan yang menghina atau bersifat rasis terhadap anggota kami
        di Stockbit.
      </li>
      <li>Menggunakan bahasa vulgar dan/atau tidak berkenan di Stockbit</li>
      <li>
        Posting yang berbau SARA (Suku, Agama, Ras, Antar golongan), pornografi
        dan segala sesuatu yang tidak sesuai untuk ditampikan secara publik. Hal
        Ini termasuk pemilihan username dan foto profil yang tidak sesuai dengan
        standar dan peraturan stockbit
      </li>
    </ul>
    <p>
      Perlakuan kasar dapat dianggap sebagai tindakan pidana. Stockbit tidak
      bertanggung jawab atas tindakan pengguna kami dan akan bekerja sama
      sepenuhnya dengan pihak berwenang jika tindakan tersebut dibawa ke ranah
      hukum.
    </p>

    <Text
      family="bold"
      as="h3"
      id="disclaimer-always-on"
      style={{ marginBottom: '0.8em' }}
    >
      Disclaimer Always On
    </Text>
    <p>
      Semua postingan dari pengguna Stockbit bukan rekomendasi untuk membeli
      atau menjual, melainkan hanya sesuatu ide untuk dipertimbangkan. Maka dari
      itu, kamu sendiri yang bertanggung jawab untuk menentukan apakah
      investasi, strategi berikut sesuai untuk kamu. Setiap post mempunyai
      disclaimer. Silahkan baca <a href="/terms">Terms of Service</a> kami.
    </p>
    <p>
      Aturan-aturan ini dibuat untuk kepentingan bersama. Pelanggaran akan
      ditindaklanjuti{' '}
      <Text family="bold" as="span">
        tanpa peringatan
      </Text>
      . Keputusan admin merupakan final atas aksi individu tanpa melihat konteks
      sebelumnya dan tanpa arbitrase berkelanjutan. Kami mohon untuk kebijakan
      semua anggota dalam menulis di Stockbit.
    </p>
    <p>
      <Text family="bold" as="span">
        ***
      </Text>
    </p>
    <Text family="bold" as="h3" id="faq" style={{ marginBottom: '0.8em' }}>
      FAQ
    </Text>
    <Text family="bold" as="h4" style={{ marginBottom: '0.8em' }}>
      Apa itu House Rules?
    </Text>
    <p>
      House Rules adalah peraturan yang dibuat oleh Superadmin dengan tujuan
      untuk menjaga percakapan dalam diskusi di Stockbit Stream tetap nyaman dan
      kondusif.
    </p>
    <p>
      Pelanggaran House Rules dapat dikenakan sanksi mulai dari teguran,
      penangguhan hingga penghapusan akun.
    </p>
    <Text family="bold" as="h4" style={{ marginBottom: '0.8em' }}>
      Bagaimana Jika Saya Melanggar House Rules?
    </Text>
    <p>
      Jika kamu melanggar, moderator kami memiliki hak untuk melakukan
      penindakan, mulai dari penindakan{' '}
      <em>
        <strong>mute</strong>
      </em>
      , menghapus, hingga menangguhkan akunmu.
    </p>
    <p>
      Moderator juga berhak untuk menghapus segala postingan bernada provokasi
      dan berpotensi menimbulkan kegaduhan.
    </p>
    <p>
      Jika kamu menemukan postingan dengan ciri-ciri yang melanggar{' '}
      <em>House Rules</em>, silakan laporkan postingan tersebut ke{' '}
      <strong>@superadmin</strong> supaya moderator kami dapat menindaklanjuti.
    </p>
    <p>
      <em>Stockbit</em> menanggapi secara serius segala pelanggaran etika dalam
      House Rules demi menjaga platform agar tetap kondusif.
    </p>
    <Text family="bold" as="h4" style={{ marginBottom: '0.8em' }}>
      Bagaimana Jika Saya Menemukan Postingan yang Melanggar?
    </Text>
    <p>
      Jika kamu menemukan postingan atau komentar yang berpotensi menimbulkan
      kegaduhan, silakan laporkan pelanggaran menggunakan fitur Report Abuse.
    </p>
    <p>
      Ikuti langkah berikut untuk menggunakan fitur{' '}
      <em>
        <strong>Report Abuse</strong>
      </em>
      :
      <ol>
        <li>
          Klik ikon titik tiga di sebelah kanan <em>username</em> yang
          memposting konten
        </li>
        <li>
          Pilih <strong>Report Abuse</strong>
        </li>
        <li>
          Pilih <strong>Report Type</strong> atau tipe pelanggaran yang
          dilakukan
        </li>
        <li>Isi alasan laporan</li>
        <li>
          Klik <strong>Confirm</strong>
        </li>
      </ol>
    </p>
    <p>
      Kamu juga dapat melaporkan langsung dengan tag langsung{' '}
      <strong>@SuperAdmin</strong>.
    </p>
    <p>
      <em>Stockbit</em> menanggapi secara serius segala pelanggaran etika dalam
      House Rules demi menjaga platform agar tetap kondusif.
    </p>
    <Text family="bold" as="h4" style={{ marginBottom: '0.8em' }}>
      Bagaimana Cara Saya <em>Block User</em>?
    </Text>
    <p>
      <strong>Fitur Block</strong> digunakan untuk memblokir <em>user</em>{' '}
      tertentu sehingga postingan orang tersebut tidak muncul di halaman Stream.
      Untuk mengaktifkan fitur ini, bisa menggunakan cara-cara berikut.
      <ol>
        <li>Klik More berupa simbol titik tiga yang tertera pada postingan</li>
        <li>
          Pilih Block User dan klik <em>Save</em>
        </li>
        <li>
          Maka postingan <em>user</em> tersebut tidak akan muncul kembali
        </li>
      </ol>
    </p>
    <p>
      <Text family="bold" as="span">
        ***
      </Text>
    </p>
  </>
);

export default Rules;
